import React, { useEffect, useState, memo } from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { useTrackInteraction } from '../../services/logging/hooks';
import { usePageContext } from '../../utils/page-context';
import { useAvailableFiscalYears } from './hooks';
import { Option, Combobox } from '../../providers/harmony-scope/lazy-enablers';

interface IProps {
  selectedFiscalYear: string;
  onChange: (fiscalYear: string) => void;
}

const componentName = 'Fiscal Year Picker Filters Panel';
export const ComponentFilterParticipationPartitionGroup = memo((props: IProps) => {
  // Props Accessors
  const { selectedFiscalYear: selectedFiscalYearProp, onChange } = props;

  // Hooks
  const { t } = useMEMTranslation();
  const pageName = usePageContext();
  const trackInteraction = useTrackInteraction();
  const availableFiscalYears = useAvailableFiscalYears();
  const [selectedFiscalYear, setSelectedFiscalYear] = useState(selectedFiscalYearProp);

  // Effects
  useEffect(() => {
    setSelectedFiscalYear(selectedFiscalYearProp);
  }, [selectedFiscalYearProp]);

  useEffect(() => {
    onChange(selectedFiscalYear);
  }, [onChange, selectedFiscalYear]);

  // Handlers
  const fiscalYearChanged = (event: any) => {
    if (!event.target.value) return;
    const newFiscalYear = event.target.value;
    trackInteraction('Selected fiscal year', pageName, componentName, {
      selectedFiscalYear: newFiscalYear,
    });
    setSelectedFiscalYear(newFiscalYear);
  };

  return (
    <>
      <Combobox label={t('filtersPanelFiscalYearLabel')} value={selectedFiscalYear} onHeChange={fiscalYearChanged}>
        {availableFiscalYears.map((fy) => (
          <Option value={`${fy}`} key={`${fy}`}>
            {fy}
          </Option>
        ))}
      </Combobox>
      <br />
    </>
  );
});
